export enum RocCalculatorModelEnum {
  CURRENT = 'Current State',
  GOAL = 'Goal State'
}
